import { createSvgIcon } from '@mui/material'

export const ChangeArrow = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 14.51L13.5 14.51L13.5 3L13.5 2.5L13 2.5L11 2.5L10.5 2.5L10.5 3L10.5 14.51L8 14.51L6.79075 14.51L7.64689 15.364L11.6469 19.354L12 19.7062L12.3531 19.354L16.3531 15.364L17.2092 14.51L16 14.51Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>,
  'ChangeArrow'
)
